import React, {Component} from "react";
import {monthOptions, yearOptions} from "../../config";
import * as R from "ramda";
import {configMonthToDateLeasing, configMonthToDatePayment} from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import {mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {fetchDataAsync} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import {transformResponseMTD} from "../config";
import moment from "moment";
class MonthToDateReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            month: null,
            year: null,
            dataSales: [],
            sales: null,
            tableConfigPayment: [],
            tableConfigLeasing: [],
            dataTablePayment: [],
            dataTableLeasing1: [],
            dataTableLeasing2: [],
        };
    };

    componentDidMount = async () => {
        const currentMonth = Number(moment().format("MM"));
        const currentYear = Number(moment().format("YYYY"));

        this.setState((prevValue) => ({
            ...prevValue,
             month: monthOptions.find((item) =>
               R.equals(item.value, currentMonth)
             ),
             year: yearOptions.find((item) =>
               R.equals(item.value, currentYear)
             ),
            tableConfigPayment: configMonthToDatePayment,
            tableConfigLeasing: configMonthToDateLeasing,
        }));
        if (!R.isNil(this.props.search) && R.equals(this.props.tab, "salesman")) {
            await this.fetchDataSales();
        }
    };

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        if (!R.equals(prevProps.search, this.props.search)) {
            if (R.equals(this.props.tab, "salesman")) await this.fetchDataSales();
            this.setState((prevValue) => ({
                ...prevValue,
            }));
            this.handleSearch();
        }
    };

    fetchData = async (isMergeLeasing) => {
       try {
         this.props.triggerLoading();
        const res = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanMTD,
          setError: this.props.setError,
          menuName: "Dashboard Level Team Leader - Laporan Penjualan Bulanan",
          args: {
            kodeCabang: [this.props.search],
            month: this.state.month?.value,
            year: this.state.year?.value,
            employeeIdSales: this.props.tab === 'salesman'? this.state.sales?.value : undefined,
            mergerLeasing: isMergeLeasing,
            employeeIdTeamLeader: this.props.idLeader
          },
        });
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            if(!isMergeLeasing){
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTablePayment: transformResponseMTD(res.data.data),
                }));
            }
            else{
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTableLeasing1: transformResponseMTD(res.data.data),
                }));
            }
        } 
        this.props.triggerLoading();
       } catch (error) {
        console.error("Error fetching data:", error);
       }
    };

    fetchDataSales = async () => {
        const { triggerLoading, setError, tab, search } = this.props;
        triggerLoading();
    
        const isSales = tab === "salesman";
        const fn = isSales ? "getSalesDropdownForDashboard" : "getAllMasterSales";
    
        let res = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA")[fn],
          setError: setError,
          menuName: "Dashboard Level Team Leader - Laporan Harian By Salesman/CS",
          args: isSales
            ? { employeeIdTeamLeader: this.props.idLeader, kodeCabang: search }
            : { paramFilters: { kodeCabang: search } },
        });
        triggerLoading();
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
          const label = isSales ? "name" : "salesLeadName";
          this.setState((prevValue) => ({
            ...prevValue,
            dataSales: res.data.data?.map((item) =>
              mapToObjectDDL(item[label], item.employeeId)
            ),
          }));
        }
      };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleSearch = () =>{
        this.fetchData()
        this.fetchData(true)
    }

    render() {
        return (
            <>
                <FlexView style={{gap: "20px", alignItems: "center"}}>
                    <SimpleDDL
                        id="select_options_month"
                        box="search"
                        name="month"
                        containerclassname="width width-250px"
                        placeholder="Bulan"
                        isClearable
                        menuPosition="fixed"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                    />
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        isClearable
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                    />
                    {R.equals(this.props.tab, "salesman") && (
                        <SimpleDDL
                            id="select_options_sales"
                            box="search"
                            name="sales"
                            isClearable
                            containerclassname="width width-250px"
                            placeholder="Select Salesman/CS"
                            menuPosition="fixed"
                            options={this.state.dataSales}
                            value={this.state.sales}
                            onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                        />
                    )}
                    <SimpleButton
                        styles={{marginBottom: "15px"}}
                        onClick={()=> this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                <FlexView style={{gap: "50px"}}>
                    <SimpleDataTable
                        data={this.state.dataTablePayment}
                        columns={this.state.tableConfigPayment}
                    />
                    <SimpleDataTable
                        data={this.state.dataTableLeasing1}
                        columns={this.state.tableConfigLeasing}
                    />
                </FlexView>
            </>
        );
    };
}

export default MonthToDateReport;